import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precipitation'
})
export class PrecipitationPipe implements PipeTransform {

  transform(value: number | undefined): string {
    if (value === undefined || value === null || isNaN(value)) {
      return '';
    }

    const rounded = Math.round(value);
    return `${rounded} l/m²`;
  }

}
